<template>
  <div id="app">
    <router-view/>
    <alert-box />
    <message-bar/>
  </div>
</template>

<script>
import AlertBox from './components/AlertBox.vue'
import MessageBar from './components/messageBar.vue'
export default {
  name: 'App',
  components:{
    AlertBox,
    MessageBar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  width:100%;
  height: 100%;
  position: absolute;
  padding: 0;
  margin: 0;
}

input {
  border: none;
  outline:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue